import React from 'react'
import { ActivitiesFav } from '../Components/Icons'
import '../Components/Styles/activities.css'
import { useRouteMatch, Link } from 'react-router-dom'
import defaultBackground from '../Components/Styles/images/card-background-default.png'

const Card = ({
  card, isActivityPickerVisible, setActivityDescriptionShown,
  setSelectedActivity, updateFavorites, favorites
}) => {
  const coverImageThumbnailUrl = card?.data?.cover_image?.thumbnail.url
  const cardTitle = card?.data?.title[0]?.text || 'No title'
  const durationMin = card?.data?.duration_min || '?'
  const durationMax = card?.data?.duration_max || '?'
  const cardText = card?.data?.description?.length === 0
    ? 'No description'
    : card?.data?.description[0]?.text
  const match = useRouteMatch()
  const fromWhatComponentClicked = e => { // this function checks in what component user has clicked
    if (isActivityPickerVisible) { // true if click was made from ActivityPickerModal while creating new event
      e.preventDefault()
      setSelectedActivity(card.id)
      setActivityDescriptionShown(true)
    }
  }

  const isFav = favorites?.find(item => item === card.id)
  return (
    <div className='card'>
      <button
        className={isFav ? 'favorites-btn-is-fav' : 'favorites-btn'}
        onClick={() => updateFavorites(card.id)}
      >
        <ActivitiesFav />
      </button>

      <Link
        to={`${match?.url}/${card?.id}`}
        onClick={fromWhatComponentClicked}
      >
        <div className='image'>
          <img
            src={coverImageThumbnailUrl || defaultBackground}
            width='270px'
            height='290px'
          />
        </div>

        <div className='description'>
          {durationMin && <span className='duration'>{`${durationMin}-${durationMax} min`}</span>}
          <span className='title'>{cardTitle}</span>
          <span className='text'>{cardText}</span>
        </div>
      </Link>
    </div>
  )
}

export default Card
